import { render, staticRenderFns } from "./RollbackModal.vue?vue&type=template&id=07b3c614"
import script from "./RollbackModal.vue?vue&type=script&lang=js"
export * from "./RollbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports